module.exports = __webpack_public_path__ + "img/ddg93-1.7b48c1c2.png";